import { useEffect, useRef } from 'react'
import { ACTIONS as A } from '../components/activityGroupReducer/activityGroupReducer'
import { ACTIVITYGROUP_MODES } from '../helpers/activityGroupModes'

// Handles route-based open/close + deep-link auto open behavior for ActivityGroup
export default function useActivityGroupRouteSync({
  isComponentMountedRef,
  locationPathname,
  answerId,
  stateIsOpen,
  dispatch,
  openPreviousAnswers,
  parsedAnswerId,
  relevantActivityGroupId,
  activitiesLength,
  cisId,
  activeCisId,
  sharedAnswers,
  activityGroupAnswerIdDerived,
  isValidParsedAnswerId,
}) {
  // Track previous path to only close on actual navigation
  const prevPathRef = useRef(locationPathname)

  useEffect(() => {
    if (!isComponentMountedRef.current) return
    const changed = prevPathRef.current !== locationPathname
    prevPathRef.current = locationPathname
    const hasAnswerInRoute = !!answerId
    if (changed && stateIsOpen && !hasAnswerInRoute) {
      dispatch({ actionType: A.SET_IS_ACTIVITY_GROUP_OPEN, value: { isActivityGroupOpen: false } })
    }
  }, [locationPathname, answerId, stateIsOpen, isComponentMountedRef, dispatch])

  // Deep link auto-open effect
  useEffect(() => {
    if (answerId && relevantActivityGroupId && activitiesLength > 0 && !stateIsOpen) {
      const cisIdToUse = cisId ? `cis.user.${cisId}` : activeCisId
      const answer = sharedAnswers?.find((shareAnswer) => shareAnswer?.id === parsedAnswerId)
      if (isValidParsedAnswerId && isComponentMountedRef.current) {
        openPreviousAnswers({
          cisUserId: cisIdToUse,
          activityGroupId: relevantActivityGroupId,
          activityGroupAnswerId: isValidParsedAnswerId ? parsedAnswerId : activityGroupAnswerIdDerived,
          isUnread: !!answer?.unread,
          activityGroupMode: answer?.completeDate ? ACTIVITYGROUP_MODES.REVIEW : ACTIVITYGROUP_MODES.INPUT,
        })
      }
    }
  }, [
    answerId,
    relevantActivityGroupId,
    activitiesLength,
    stateIsOpen,
    cisId,
    activeCisId,
    sharedAnswers,
    parsedAnswerId,
    openPreviousAnswers,
    isValidParsedAnswerId,
    isComponentMountedRef,
    activityGroupAnswerIdDerived,
  ])
}
